(function () {
  var home = window.JOVSHome;
  if (!home) return;

  function getTopBannerControls() {
    return {
      progressFill: document.querySelector("#section-top-banner .swiper-progress-bar-fill"),
      prevButton: document.querySelector("#section-top-banner .swiper-top-banner-progress .btn-swiper-prev"),
      nextButton: document.querySelector("#section-top-banner .swiper-top-banner-progress .btn-swiper-next"),
    };
  }

  function destroyTopBannerSwiper() {
    if (!home.swiperTopBanner) return;
    home.swiperTopBanner.destroy(true, true);
    home.swiperTopBanner = null;
    home.topBannerReady = false;
  }

  function updateTopBannerProgress(swiper, progressFill) {
    if (!progressFill || !swiper) return;
    var stepsCount = Array.prototype.filter.call(swiper.slides, function (slide) {
      return !slide.classList.contains("swiper-slide-duplicate");
    }).length;
    if (!stepsCount) return;
    var currentStep = (typeof swiper.realIndex === "number" ? swiper.realIndex : 0) + 1;
    progressFill.style.width = (currentStep / stepsCount) * 100 + "%";
  }

  function initTopBannerSwiper(swiperEl) {
    if (!swiperEl || typeof Swiper === "undefined") return null;
    if (!home.runtimeReady) return null;

    destroyTopBannerSwiper();

    var controls = getTopBannerControls();
    home.swiperTopBannerProgressFill = controls.progressFill;
    home.swiperTopBannerPrevButton = controls.prevButton;
    home.swiperTopBannerNextButton = controls.nextButton;

    var enableAutoplay = swiperEl.dataset.autoplay === "true";
    var autoplayDelay = parseInt(swiperEl.dataset.autoplayDelay || "5000", 10);
    var enableLoop = swiperEl.dataset.loop !== "false";
    var pauseOnHover = swiperEl.dataset.pauseOnHover !== "false";

    var config = {
      spaceBetween: 0,
      loop: enableLoop,
      navigation: {
        nextEl: home.swiperTopBannerNextButton,
        prevEl: home.swiperTopBannerPrevButton,
      },
      on: {
        init: function (swiper) {
          updateTopBannerProgress(swiper, home.swiperTopBannerProgressFill);
          home.requestTopBannerVideoSync(swiper);
        },
        slideChange: function (swiper) {
          updateTopBannerProgress(swiper, home.swiperTopBannerProgressFill);
          home.requestTopBannerVideoSync(swiper);
        },
        slideChangeTransitionEnd: function (swiper) {
          updateTopBannerProgress(swiper, home.swiperTopBannerProgressFill);
        },
        resize: function (swiper) {
          updateTopBannerProgress(swiper, home.swiperTopBannerProgressFill);
          home.requestTopBannerVideoSync(swiper);
        },
      },
    };

    if (enableAutoplay) {
      config.autoplay = {
        delay: Number.isFinite(autoplayDelay) ? autoplayDelay : 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover,
      };
    }

    home.swiperTopBanner = new Swiper(swiperEl, config);
    home.topBannerReady = true;
    return home.swiperTopBanner;
  }

  function initTopBannerInSection(sectionEl) {
    if (!sectionEl) return;
    var swiperEl = sectionEl.querySelector(".swiper-top-banner");
    if (!swiperEl) return;
    initTopBannerSwiper(swiperEl);
  }

  function bootTopBanner() {
    if (!home.runtimeReady || home.topBannerReady) return;
    var swiperEl = document.querySelector(".swiper-top-banner");
    initTopBannerSwiper(swiperEl);
  }

  if (home.runtimeReady) {
    bootTopBanner();
  } else {
    var runtimeWatcher = window.setInterval(function () {
      if (!home.runtimeReady) return;
      window.clearInterval(runtimeWatcher);
      bootTopBanner();
    }, 50);
  }

  document.addEventListener("shopify:section:load", function (event) {
    var sectionEl = document.getElementById("shopify-section-" + event.detail.sectionId);
    if (!sectionEl || !sectionEl.querySelector(".swiper-top-banner")) return;
    initTopBannerInSection(sectionEl);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var sectionEl = document.getElementById("shopify-section-" + event.detail.sectionId);
    if (!sectionEl || !sectionEl.querySelector(".swiper-top-banner")) return;
    destroyTopBannerSwiper();
  });

  document.addEventListener("shopify:block:select", function (event) {
    if (!home.swiperTopBanner || !event.detail.blockId) return;
    var slides = Array.prototype.filter.call(home.swiperTopBanner.slides, function (slide) {
      return !slide.classList.contains("swiper-slide-duplicate");
    });
    var targetIndex = -1;
    Array.prototype.forEach.call(slides, function (slide, index) {
      if (slide.dataset.blockId === event.detail.blockId) targetIndex = index;
    });
    if (targetIndex < 0) return;
    if (typeof home.swiperTopBanner.slideToLoop === "function") {
      home.swiperTopBanner.slideToLoop(targetIndex);
    } else {
      home.swiperTopBanner.slideTo(targetIndex);
    }
    updateTopBannerProgress(home.swiperTopBanner, home.swiperTopBannerProgressFill);
    home.requestTopBannerVideoSync(home.swiperTopBanner);
  });
})();
